import { Component, OnInit } from '@angular/core';
import {UtilityService} from '../../../services/utility-service';
import {NavigationEnd, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {filter} from 'rxjs/operators';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-accounting-reports',
  templateUrl: './accounting-reports.component.html',
  styleUrls: ['./accounting-reports.component.scss']
})
export class AccountingReportsComponent implements OnInit {
  dailyReports!: any[];
  monthlyReports!: any[];
  adhocReports!: any[];
  isExternalUser!: boolean;
  isWellsFargoUser!: boolean;
  selectedReport!: string;
  title = 'Reports';
  previousUrl!: string;
  constructor(private utilService: UtilityService, private router: Router, private titleService: Title,
              private cdr: ChangeDetectorRef) {


    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.previousUrl = event.url;
      this.cdr.detectChanges();
    });
  }
  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    const isExternal = JSON.parse(sessionStorage.getItem('isExternal') ?? 'false');
    this.isExternalUser = (isExternal == null) ? false : isExternal;

    const isWellsFargo = JSON.parse(sessionStorage.getItem('isWellsFargoUser') ?? 'false');
    this.isWellsFargoUser = (isWellsFargo == null) ? false : isWellsFargo;

    this.getDailyReports();
    this.getMonthlyReports();
    this.getAdhocReports();
  }

  getDailyReports()
  {

    this.dailyReports = [];

    this.dailyReports.push({label:'', value:'' });
    this.dailyReports.push({label:'01-Disbursement Reconciliation Report (Detailed)', value:'RPT_01' });
    this.dailyReports.push({label:'02-Disbursement Reconciliation Report (Summary)', value:'RPT_02' });

    if (!this.isExternalUser)
    {
      this.dailyReports.push({label:'22-ACH Servicing Transactions Report', value:'RPT_22' });
    }

    this.dailyReports.push({label:'24-Manual Load Report (Summary)', value:'RPT_24' });

    if (!this.isExternalUser)
    {
      this.dailyReports.push({label:'25-Detailed Liquidation Report', value:'RPT_25' });
    }

    this.dailyReports.push({label:'26-Servicing Transactions Upload Report', value:'RPT_26' });
    this.dailyReports.push({label:'27-Servicing Transfer Data Log Report', value:'RPT_27' });
    this.dailyReports.push({label:'28-Trial Balance Reconciliation Exception Report', value:'RPT_28' });
    this.dailyReports.push({label:'29-Trial Balance UPB Compare Report', value:'RPT_29' });

    if (!this.isExternalUser)
    {
      this.dailyReports.push({label:'30-Trial Balance Status Report', value:'RPT_30' });
    }

    this.dailyReports.push({label:'31-Trial Balance Upload Status Report', value:'RPT_31' });
    this.dailyReports.push({label:'RSS01-WD Draft Notification Detail Report - Servicing', value:'RPT_RSS_01' });

    if (!this.isExternalUser)
    {
      this.dailyReports.push({label:'RSS02-WD Daily Reconciliation Report - Servicing', value:'RPT_RSS_02' });
      this.dailyReports.push({label:'RSS03-WD Reconciliation Report - MIP and Service Fee', value:'RPT_RSS_03' });
      this.dailyReports.push({label:'RSS04-WD Reconciliation Report - Scheduled Payments', value:'RPT_RSS_04' });
    }
  }


  getMonthlyReports() {
    this.monthlyReports = [];

    this.monthlyReports.push({label:'', value:'' });
    this.monthlyReports.push({label:'01-Disbursement Reconciliation Report (Detailed)', value:'RPT_01' });
    this.monthlyReports.push({label:'02-Disbursement Reconciliation Report (Summary)', value:'RPT_02' });
    this.monthlyReports.push({label:'03-Net Principal Limit', value:'RPT_03' });
    this.monthlyReports.push({label:'04-LOC Reserve', value:'RPT_04' });
    this.monthlyReports.push({label:'05-Loan Adjustment Report (Detailed Listing)', value:'RPT_05' });
    this.monthlyReports.push({label:'07-Portfolio Loan Balance Report (Summary Listing)', value:'RPT_07' });
    this.monthlyReports.push({label:'08-Reverse Mortgage Rate Changes', value:'RPT_08' });

    if (!this.isExternalUser)
    {
      // only for internal users
      this.monthlyReports.push({label:'09-Monthly Reconciliation File (UPB)', value:'RPT_09' });
      this.monthlyReports.push({label:'10-Monthly Reconciliation File (MIP)', value:'RPT_10' });
      this.monthlyReports.push({label:'11-Monthly Reconciliation File (Service Fee)', value:'RPT_11' });
    }

    this.monthlyReports.push({label:'12-Servicing Transfer Detail Report By Lender', value:'RPT_12' });

    if (!this.isExternalUser)
    {
      // only for internal users
      this.monthlyReports.push({label:'14B-Yield Extract Report', value:'RPT_14B' });
      this.monthlyReports.push({label:'15-Outstanding Maximum Claim Amount Report', value:'RPT_15' });
      this.monthlyReports.push({label:'16-HECM FIXED Rate Monthly Interest Reconciliation Report', value:'RPT_16' });
      this.monthlyReports.push({label:'17-HECM ARMS Monthly Interest Income Reconciliation Report', value:'RPT_17' });
      this.monthlyReports.push({label:'18-HKM Monthly Interest Reconciliation File Report (4129)', value:'RPT_18' });
    }

    this.monthlyReports.push({label:'19-Servicer Portfolio Summary Report', value:'RPT_19' });
    this.monthlyReports.push({label:'20-First Year Property Charge Rollover Report', value:'RPT_20' });
    this.monthlyReports.push({label:'21-Early Warning Report', value:'RPT_21' });

    if (!this.isExternalUser)
    {
      // only for internal users
      this.monthlyReports.push({label:'23-Scheduled/Unscheduled Transactions Report', value:'RPT_23' });
      this.monthlyReports.push({label:'32-Portfolio Activity Report', value:'RPT_32' });
      this.monthlyReports.push({label:'33-Liquidated Loans Report', value:'RPT_33' });
    }

    this.monthlyReports.push({label:'35-Data Extract Download Report', value:'RPT_35' });

    if (!this.isExternalUser)
    {
      this.monthlyReports.push({label:'36-Servicing Statistics Report', value:'RPT_36' });
      this.monthlyReports.push({label:'37-Outstanding Adjusted Property Value Report', value:'RPT_37' });
    }

    if (!this.isExternalUser || this.isWellsFargoUser) {
      // only for internal users, and external user
      // if they are a Wells Fargo user
      this.monthlyReports.push({label:'38-Interest Extract Report', value:'RPT_38' });
    }

    this.monthlyReports.push({label:'39-Scheduled Payments Reject Report', value:'RPT_39' });

    if (!this.isExternalUser) {
      // only for internal users
      this.monthlyReports.push({label:'40-Monthly Adjustments Report', value:'RPT_40' });
    }
  }

  getAdhocReports() {
    this.adhocReports = [];

    this.adhocReports.push({label:'', value:'' });
    this.adhocReports.push({label:'06-Portfolio Loan Balance Report (Detailed Listing)', value:'RPT_06' });
    this.adhocReports.push({label:'13-Servicing Disbursement Report', value:'RPT_13' });
    this.adhocReports.push({label:'24A-Manual Load Summary Adhoc Report', value:'RPT_24a' });

    if (!this.isExternalUser) {
      // only for internal users
      this.adhocReports.push({label: '25A-Detailed Liquidation Adhoc Report', value: 'RPT_25a'});
      this.adhocReports.push({label: '30A-Trial Balance Status Report', value: 'RPT_30a'});
    }


  }

  reportChange(reportType: string)
  {
    sessionStorage.setItem('reportCode', this.selectedReport );
    if (reportType === 'Daily Report')
    {
      this.dailyReports.forEach(reportName=>{
        if (reportName.value === this.selectedReport)
        {
          sessionStorage.setItem('reportName', reportName.label );
        }
      });
    } else if (reportType === 'Monthly Report')
    {
      this.monthlyReports.forEach(reportName=>{
        if (reportName.value === this.selectedReport)
        {
          sessionStorage.setItem('reportName', reportName.label );

        }
      });
    }
    else {

      this.adhocReports.forEach(reportName=>{
        if (reportName.value === this.selectedReport)
        {
          sessionStorage.setItem('reportName', reportName.label );
        }
      });
    }
    this.router.navigate(['/reportCreiteria'], {queryParams:{
      reportType:reportType,
      previousUrl:this.previousUrl
    }});
  }

}
